import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getKlausurFromFile } from "../../actions/currentKlausur";
import { Row,Col } from "react-bootstrap";
import { addAllSchuelerDummy } from "../../actions/schueler";

const OpenInput = ({ setView }) => {
  console.log('????????????????????????')
  const [loadError, setLoadError] = useState(null);
  const dispatch = useDispatch();
  const loadKlausur = (result) => {
    try {
      const obj = JSON.parse(result);
      const klausur = obj.klausur || {};
      const schueler = obj.schueler || [];
      dispatch(getKlausurFromFile(klausur));
      dispatch(addAllSchuelerDummy(schueler))
      setView("klausur");
    } catch (err) {
      console.error({ err });
      setLoadError("Ungültige Projektdatei");
      setTimeout(() => {
        setLoadError(null);
        setView("buttons");
      }, 3000);
    } finally {
      // console.log("finally");
    }
  };

  useEffect(() => {
    const inputField = document.getElementById("inputfile");
    try {
      
      inputField.addEventListener("change", function () {
        // console.log({inputField})
        let fr = new FileReader();
        fr.onload = function () {
          loadKlausur(fr.result);
          // console.log(JSON.parse(fr.result));
          const output = document.getElementById("output");
          if (output) output.textContent = fr.result;
        };

        fr.readAsText(this.files[0]);
      });
    } catch (err) {
      console.error({ err });
    }
  });

  return (
    <div className="mt-3 p-3">
      {loadError && <p className="text-danger">Ungültige Projektdatei</p>}
      <Row>
        <Col><input type="file" name="inputfile" id="inputfile" /></Col>
        <Col><button className="btn btn-outline-secondary" onClick={()=>setView("buttons")}>Abbrechen</button></Col>
        <Col></Col>
      </Row>
      
      
    </div>
  );
};
export default OpenInput;
